import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Tooltip from '@mui/material/Tooltip';
import { Modal } from 'react-bootstrap';
import { CloseIcon, SearchesCIcon } from '../../../assets/Icons';
import logo from "../../../assets/images/logo.png";
import apiClient from '../../../apiClient/index';
import { CREATE_RESOURCE, UNVERIFIED_RESOURCE } from '../../../apiClient/apiEndpoints';
import { useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { BtnLoading } from '../../utils/operation';
import NoDataFound from '../NoDataFound/NoDataFound';



const Dashboard = () => {
  const navigator = useNavigate();
  const params = useParams();
  const configData = useSelector((state) => state.configSlice);
  const tagsData = useSelector((state) => state.tagsSlice);
  const userData = useSelector((state) => state.userSlice);
  const [searchText, setSearchText] = useState("");
  const [showAddModule, setShowAddModule] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [moduleName, setModuleName] = useState("");
  const [list, setList] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(true);



  const getResourceUnverified = async () => {
    try {
      setFetchingLoading(true);
      let data = await apiClient.get(`${configData.config.UNO_URL}${UNVERIFIED_RESOURCE}/module`)
      setList(data);

    } catch (error) {
      console.log(error);
    }finally{
      setFetchingLoading(false);
    }
  }

  useEffect(() => {
    getResourceUnverified()
  }, []);

  const handleCloseModule = () => {
    setShowAddModule(false);
    setLoading(false);
    setModuleName("");
    setError(null);
  }

  const handleSaveModule = async () => {
    if(loading) return;
    try {
      setError(null);
      if(moduleName.trim().length === 0){
        setError("Kindly fill name.");
        return
      }
      setLoading(true);

      let _bodyData = {
        name: moduleName
      }

      await apiClient.post(`${configData.config.UNO_URL}${CREATE_RESOURCE}/module`, _bodyData)
      getResourceUnverified();
      handleCloseModule();

    } catch (error) {
      console.error(error);
      setError("Something went wrong");
    }finally{
      setModuleName("");
      setLoading(false);
    }
    
  }

  let filterList = list.filter(item => 
    !searchText || item.name.toLowerCase().includes(searchText.toLowerCase())
   );

  return (
    <>
      <Helmet>
        <title> XR Modules | Simulanis ModuleVault </title>
      </Helmet>

      <div className="stuckhere modules">
        <div className="row">

          <div className="col-lg-6">
            <form className="app-search app-search1 d-flex justify-content-start">
              <div className="position-relative">
                <SearchesCIcon />
                <input
                  placeholder="Search Modules...."
                  className="form-control"
                  type="text"
                  value={searchText} 
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </form>
          </div>

          <div className="col-lg-6 d-flex align-items-center justify-content-end mainbtns">
            {/* <button className="createbtn" onClick={() => setShowAddModule(true)}>Add Modules</button> */}
          </div>

        </div>
      </div>


      <div className="lowersection">
        <div className="container-fluid px-4">
          <div className="modulelist">
          {fetchingLoading ?
           <div className='d-flex align-items-center justify-content-center'>
               <NoDataFound nodatatext={"Data is fetching."}/>
           </div>
            :
            <>
            {filterList.length > 0 ?
              <div className="course-tiles">
                {filterList.map((item, index) => {
                  let thumbnail = item.versions[0].data.thumbnail;
                  return (
                    <div className="tilecard" key={item.uuid} onClick={() => navigator(`/dashboard/xr/details/${item.uuid}`)}>
                      <div className="modulecard module">
                        <div className="moduleicon">
                          {thumbnail ? (
                            <img src={thumbnail} alt={item.name} />
                          ) : (
                            <img src={logo} className='defaultimg' alt={item.name} />
                          )}
                        </div>
                        <div className="moduledata">
                          <Tooltip title="Static Module Name">
                            <p className="modulename">{item.name}</p>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
              :
              <div className='d-flex align-items-center justify-content-center'>
              <NoDataFound nodatatext={"No data found."}/>
              </div>
             }
            </>
            }

          </div>
        </div>
      </div>


      <Modal show={showAddModule} onHide={handleCloseModule} className="NewModule" centered size="md">
        <Modal.Header className='modalheader'>
          Enter Module Details
          <span onClick={handleCloseModule} ><CloseIcon /></span>
        </Modal.Header>
        <Modal.Body>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12 mb-2'>
                <div className="form-group">
                  <p className="label pb-2">Name</p>
                  <input autoComplete="off" placeholder='Module Name' name="moduleName" id="moduleName" value={moduleName} onChange={(e) => setModuleName(e.target.value)} className="input form-control" type="text" />
                </div>
                <p className='error'>{error}</p>
              </div>

            </div>
          </div>

        </Modal.Body>

        <Modal.Footer className='footerbtn pt-0'>
          <Button onClick={handleCloseModule}> Cancel </Button>
          <Button onClick={handleSaveModule}> {loading ? <BtnLoading /> : "Save" } </Button>
        </Modal.Footer>

      </Modal>


    </>
  )
}

export default Dashboard
